// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   selectedProject: null,
// };

// const projectSlice = createSlice({
//   name: 'projects',
//   initialState,
//   reducers: {
//     selectProject: (state, action) => {
//       state.selectedProject = action.payload;
//     },
//   },
// });

// export const { selectProject } = projectSlice.actions;

// export default projectSlice.reducer;


import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  projects: [],
  selectedProject: null,
  columnVisible: {
    name: true,
    description: false,
    context: false,
    moduleCount: true,
    testCaseCount: true,
    testRunCount: false,
    created_at: true,
    createdByUser: true, 
    actions: true,
    isListView: true,
  },
};

const projectSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    addProject: (state, action) => {
      state.projects.push({
        id: Date.now(),
        ...action.payload,
        createdAt: new Date().toISOString(),
      });
    },
    selectProject: (state, action) => {
      state.selectedProject = action.payload;
    },
    updateProject: (state, action) => {
      const index = state.projects.findIndex(p => p.id === action.payload.id);
      if (index !== -1) {
        state.projects[index] = { ...state.projects[index], ...action.payload };
      }
    },
    deleteProject: (state, action) => {
      state.projects = state.projects.filter(p => p.id !== action.payload);
      if (state.selectedProject?.id === action.payload) {
        state.selectedProject = null;
      }
    },
    setProjectListVisibleColumn: (state, action) => {
      state.columnVisible = action.payload;
    },
    setIsListView: (state, action) => {
      state.isListView = action.payload;
    },
  },
});

export const { addProject, selectProject, updateProject, deleteProject, setProjectListVisibleColumn, setIsListView } = projectSlice.actions;
export default projectSlice.reducer;
